import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'

import styles from './fixed_gradient.less'
import { getScrollDist } from 'lib/scroll'

const FIXED_GRADIENT_PADDING = 12

class FixedGradient extends React.Component {
  static propTypes = {
    enabled: PropTypes.bool,
    children: PropTypes.any,
    styles: PropTypes.object,
  }

  state = {
    overscrolled: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  }

  handleScroll = () => {
    if (!this.root.offsetParent) {
      // weirdness, sometimes we get null as the offset parent, so let's disable that
      return
    }
    this.setState({
      overscrolled: getScrollDist(this.root) <= FIXED_GRADIENT_PADDING,
    })
  }

  render() {
    const shouldShow = this.props.enabled && this.state.overscrolled

    return (
      <div
        ref={root => {
          this.root = root
        }}
      >
        {shouldShow && (
          <div styleName="fixed-gradient-container" data-fixed="true">
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

export default cssModules(FixedGradient, styles, { allowMultiple: true })
